import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getCropTypeList,
	addNewCropType,
	updateCropType,
	deleteCropType,
	getCropType,
} from '../cropType/thunk';

export const initialState = {
	itemCropTypeList: [],
	itemCropTypeDetail: null,
	isCropTypeLoading: false,
	isCropTypeSuccess: false,


	cropTypeList: [],
	cropTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const CropTypeSlice = createSlice({
	name: 'CropType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getCropType.fulfilled, (state, action) => {
			state.isCropTypeLoading = false;
			state.isCropTypeSuccess = true;
			state.itemCropTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getCropType.pending, state => {
			state.isCropTypeLoading = true;
			state.isCropTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getCropType.rejected, (state, action) => {
			state.isCropTypeLoading = false;
			state.isCropTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getCropTypeList.pending, state => {
			state.isCropTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getCropTypeList.fulfilled, (state, action) => {
			state.itemCropTypeList = action.payload;
			state.cropTypeList = action.payload;
			state.isLoadingList = false;
			state.isCropTypeSuccess = true;

			let cropTypeListSelect = [];
			action.payload.map(item =>
				cropTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.cropTypeListSelect = cropTypeListSelect;
		});
		builder.addCase(getCropTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isCropTypeSuccess = true;
		});
		builder.addCase(addNewCropType.fulfilled, (state, action) => {
			state.itemCropTypeList.push(action.payload);
			state.cropTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewCropType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewCropType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateCropType.fulfilled, (state, action) => {
			state.itemCropTypeList = state.itemCropTypeList.map(cropType =>
				cropType.cropTypename === action.payload.old_cropType
					? { ...cropType, ...action.payload.updated_cropType }
					: cropType
			);
			state.cropTypeList = state.cropTypeList.map(cropType =>
				cropType._id.toString() === action.payload._id.toString()
					? { ...cropType, ...action.payload }
					: cropType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateCropType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateCropType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteCropType.fulfilled, (state, action) => {
			state.itemCropTypeList = current(state.itemCropTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.cropTypeList = current(state.cropTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteCropType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteCropType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = CropTypeSlice.actions;

export default CropTypeSlice.reducer;
